// Keep fixed-header spacing accurate when the announcement wraps, fonts load,
// or the theme editor changes its text.
(function () {
  var resumeTimer;
  document.addEventListener('scroll', function () {
    document.documentElement.setAttribute('data-announcement-scrolling', '');
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function () {
      document.documentElement.removeAttribute('data-announcement-scrolling');
    }, 700);
  }, {capture: true, passive: true});
  function fillAnnouncements() {
    document.querySelectorAll('.scrolling-announcement').forEach(function (banner) {
      var groups = Array.from(banner.querySelectorAll('.scrolling-announcement__group'));
      if (groups.length !== 2) return;
      var originals = Array.from(groups[0].children).filter(function (item) { return !item.hasAttribute('data-announcement-copy'); });
      var sequenceWidth = originals.reduce(function (width, item) { return width + item.getBoundingClientRect().width; }, 0);
      if (!sequenceWidth) return;
      var repeats = Math.max(1, Math.ceil((banner.clientWidth + 1) / sequenceWidth));
      if (groups[0].dataset.repeatCount === String(repeats)) return;
      groups.forEach(function (group) {
        group.querySelectorAll('[data-announcement-copy]').forEach(function (item) { item.remove(); });
        for (var repeat = 1; repeat < repeats; repeat++) {
          originals.forEach(function (item) {
            var copy = item.cloneNode(true);
            copy.setAttribute('data-announcement-copy', '');
            group.appendChild(copy);
          });
        }
        group.dataset.repeatCount = String(repeats);
      });
    });
  }
  fillAnnouncements();
  window.addEventListener('resize', function () { requestAnimationFrame(fillAnnouncements); });
  window.addEventListener('load', fillAnnouncements);
  document.addEventListener('shopify:section:load', fillAnnouncements);
  document.addEventListener('textual:shipping-country-changed', fillAnnouncements);
  if (document.fonts) document.fonts.ready.then(fillAnnouncements);
  var header = document.querySelector('.js-header');
  var main = document.querySelector('.main-content');
  if (!header || !main || !window.ResizeObserver) return;
  function syncSpacing() {
    if (getComputedStyle(header).position === 'fixed') {
      main.style.setProperty('margin-top', header.getBoundingClientRect().height + 'px', 'important');
    }
  }
  var observer = new ResizeObserver(syncSpacing);
  observer.observe(header);
  window.addEventListener('load', function () { requestAnimationFrame(syncSpacing); });
  window.addEventListener('resize', function () { requestAnimationFrame(syncSpacing); });
}());
